import React, { useState, useEffect } from 'react'; // Import the 'React' module
import { Header } from "../components/Header";
import  NavBar  from "../components/NavBar";


interface LoggedHomeProps {
    children: React.ReactNode;
}

function LoggedLayout({children}: LoggedHomeProps) {
    // Estado para controlar si estamos en desktop o mobile
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
    const NAVBAR_MOBILE_HEIGHT_CLASS = 'pb-[4.6rem]'

    // Listener para cambios de tamaño de pantalla
    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
             <div className="min-h-screen flex flex-col w-full dark:bg-gray-900 bg-gray-200" data-testid="logged-layout">
                {/* Header: sticky, ocupa su espacio en la parte superior */}
                <header className="sticky top-0 z-10" data-testid="logged-layout-header">
                    <Header />
                </header>
                
                {/* NavBar: fixed, no interrumpe el flujo de main, pero main necesita considerarlo */}
                <NavBar /> 
                
                {/* Contenido Principal (Main) */}
                <main 
                    className={`flex flex-col flex-grow overflow-auto ${isDesktop ? 'ml-24' /* Espacio para NavBar desktop */ : NAVBAR_MOBILE_HEIGHT_CLASS /* Padding inferior para NavBar mobile */}`}
                    data-testid="logged-layout-main"
                >
                    {/* Contenedor del contenido dentro de Main */}
                    {/* Este div se expandirá para llenar 'main' y centrará a 'children' */}
                    <div 
                        className="flex-grow flex items-center justify-center w-full" 
                        data-testid="logged-layout-content"
                    >
                        {children}
                    </div>
                </main>
            </div>
    )
}

export {LoggedLayout};